import {
  add as collectionAdd
} from 'diagram-js/lib/util/Collections';

import {
  getBusinessObject
} from '../../../../base/BaseServices';

/**
 * Creates a new bpmn:CategoryValue inside a new bpmn:Category
 *
 * @param {ModdleElement} definitions
 * @param {BpmnFactory} bpmnFactory
 *
 * @return {ModdleElement} categoryValue.
 */
export function createCategoryValue(definitions, bpmnFactory) {
  // Create CategoryValue and Category using bpmnFactory
  const categoryValue = bpmnFactory.create('bpmn:CategoryValue');
  const category = bpmnFactory.create('bpmn:Category', {
    categoryValue: [categoryValue],
  });

  // Add Category to the rootElements collection
  collectionAdd(definitions.get('rootElements'), category);

  // Set $parent for Category and CategoryValue
  const categoryBusinessObject = getBusinessObject(category);
  const categoryValueBusinessObject = getBusinessObject(categoryValue);

  categoryBusinessObject.$parent = definitions;
  categoryValueBusinessObject.$parent = category;

  return categoryValue;
}